/* eslint-disable no-template-curly-in-string */
import { setLocale } from "yup";

// Mensagens padrão do Yup em português, usadas quando o schema não passa
// um texto próprio (ex.: `.required()` sem argumento).
setLocale({
  mixed: {
    default: "Valor inválido",
    required: "Obrigatório",
    oneOf: "Valor não permitido",
    notOneOf: "Valor não permitido",
    notType: "Valor inválido",
  },
  string: {
    length: "Deve ter exatamente ${length} caracteres",
    min: "Deve ter no mínimo ${min} caracteres",
    max: "Deve ter no máximo ${max} caracteres",
    matches: "Formato inválido",
    email: "E-mail inválido",
    url: "URL inválida",
    trim: "Não pode ter espaços no início ou no fim",
    lowercase: "Deve estar em letras minúsculas",
    uppercase: "Deve estar em letras maiúsculas",
  },
  number: {
    min: "Deve ser maior ou igual a ${min}",
    max: "Deve ser menor ou igual a ${max}",
    lessThan: "Deve ser menor que ${less}",
    moreThan: "Deve ser maior que ${more}",
    positive: "Deve ser um número positivo",
    negative: "Deve ser um número negativo",
    integer: "Deve ser um número inteiro",
  },
  date: {
    min: "Data deve ser posterior a ${min}",
    max: "Data deve ser anterior a ${max}",
  },
  array: {
    min: "Deve ter no mínimo ${min} itens",
    max: "Deve ter no máximo ${max} itens",
  },
});
